import { create } from 'zustand';

interface ModalStoreTypes {
	activeModal: null | string;
	closingModal: null | string;
	openModal: (modalName: string, data?: any) => void;
	closeModal: (afterClose?: unknown) => void;
	data?: any;
}

const modalExitUnmountDelay = 160;
let closeTimer: ReturnType<typeof setTimeout> | undefined;

export const useModalStore = create<ModalStoreTypes>(set => ({
	activeModal: null,
	closingModal: null,
	openModal: (modalName: string, data: any = undefined) => {
		if (closeTimer) {
			clearTimeout(closeTimer);
		}

		set({
			activeModal: modalName,
			closingModal: null,
			data,
		});
	},
	closeModal: afterClose => {
		const afterCloseCallback = typeof afterClose === 'function' ? afterClose : undefined;

		set(state => {
			if (!state.activeModal || state.closingModal) {
				return state;
			}

			return {
				closingModal: state.activeModal,
			};
		});

		if (closeTimer) {
			clearTimeout(closeTimer);
		}

		closeTimer = setTimeout(() => {
			set({
				activeModal: null,
				closingModal: null,
				data: undefined,
			});
			afterCloseCallback?.();
		}, modalExitUnmountDelay);
	},
}));
